// src/comps/commpage.jsx
import {
  Navbar,
  ProjectsSection,
  Testimonials,
  Resources,
} from "../App";
import homepageImage from "../assets/homepage.jpg";
import communityImage from "../assets/Community.jpg";
import eventsImage from "../assets/events.jpg";
import { useNavigate } from "react-router-dom";

export default function CommPage() {
  const navigate = useNavigate();

  const handleViewMembers = () => {
    navigate("/community-members");
  };

  return (
    <div className="min-h-screen w-screen ">
      <Navbar />
      <div className="container mx-auto px-4">
        <CustomProjectsSection
          header="Community"
          para="We are proud to have completed a variety of impactful projects, many of which have supported nonprofit organizations. Whether it's building tools, organizing events, or empowering communities, our mission-driven work aims to create lasting, positive change."
          imagePath={homepageImage}
          imageFirst={true}
          onViewMembers={handleViewMembers}
        />

        <ProjectsSection
          header="Events"
          para="Join us for memorable gatherings and community activities. Check out our upcoming Annual Reunion Gala Night and other events that bring our batch together."
          btnName="View Events"
          imagePath={eventsImage}
          linkTo="/events"
        />

        <ProjectsSection
          header="Projects"
          para="We have completed various projects in the past. Our projects are always successful and we are proud of them."
          btnName="View Projects"
          imagePath={communityImage}
          linkTo="/projects"
        />

        <Testimonials />

        <Resources />
      </div>
    </div>
  );
}

export const CustomProjectsSection = ({
  header,
  para,
  imagePath,
  imageFirst,
  onViewMembers,
}) => {
  return (
    <section className="py-12">
      <div className="flex flex-col lg:flex-row items-center gap-8">
        {imageFirst && (
          <div className="lg:w-1/2 flex justify-center">
            <img
              src={imagePath}
              alt={header}
              className="w-2/3 lg:w-2/3 rounded-lg border-2 border-[#800000] shadow-lg"
            />
          </div>
        )}

        <div className="lg:w-1/2 space-y-4">
          <h1 className="text-black text-5xl font-bold">{header}</h1>
          <p className="text-black text-lg">{para}</p>
          <div className="pt-2">
            <button
              onClick={onViewMembers}
              className="bg-[#800000] text-white font-bold py-2 px-6 rounded-lg hover:bg-black transition"
            >
              View Community Members
            </button>
          </div>
        </div>

        {!imageFirst && (
          <div className="lg:w-1/2 flex justify-center">
            <img
              src={imagePath}
              alt={header}
              className="w-2/3 lg:w-2/3 rounded-lg border-2 border-[#800000] shadow-lg"
            />
          </div>
        )}
      </div>
    </section>
  );
};
